import {createGlobalStyle} from "styled-components";
import {normalize} from "styled-normalize";
import {reset} from "./reset";
import {getColorFromTheme} from "../utils/style.utils";

export const GlobalStyles = createGlobalStyle`
    ${normalize}
    ${reset}
    body, #root{
        /* Safe area insets for all sides */
        padding-top: env(safe-area-inset-top);
        padding-left: env(safe-area-inset-left);
        padding-right: env(safe-area-inset-right);
        padding-bottom: env(safe-area-inset-bottom);

        /* Fallback for older browsers */
        padding-top: constant(safe-area-inset-top);
        padding-left: constant(safe-area-inset-left);
        padding-right: constant(safe-area-inset-right);
        padding-bottom: constant(safe-area-inset-bottom);
        
        margin: 0;
        min-height: 100vh;
        min-height: -webkit-fill-available;
        box-sizing: border-box;
    }
    body {
        font-family: ${(props: any) => props.theme.fontFamily};
        margin: 0;
        padding: 0;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: inherit;
        text-rendering: optimizeLegibility;
        height: 100%;
        background: var(--color-secondary);
        min-width: 320px;
    }

    [data-theme="dark"] & body {
        background: var(--color-secondary-light);
    }
    .inherit-all{
        all: inherit!important;
    }
    ${({theme}: { theme: any }) => theme.breakpoints.down('sm')} {
        body {
            overflow: auto;
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.down('sm')} {
        .grotesk-fnt {
            font-family: Inter, sans-serif !important;
        }
    }

    html, body, main {
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        scroll-behavior: smooth;
        scroll-snap-type: y mandatory;
    }

    svg {
        width: 1em;
        color: inherit;

        path {
            color: inherit;
        }
    }

    * {
        box-sizing: border-box;
        border-width: 0;
        border-style: solid;
        border-top-style: solid;
        border-right-style: solid;
        border-bottom-style: solid;
        border-left-style: solid;
        border-color: #e5e7eb;
        color: var(--color-text);
        scrollbar-width: none!important;
        scrollbar-track-color: transparent;
    }

    * &::-webkit-scrollbar {
        width: 10px;
    }
    .bg-custom-card{
        background: #FFFFFF;
        box-shadow: var(--shadow-custom);

        [data-theme="dark"] & {
            background: var(--color-secondary);
        }
    }
    /* Handle on hover */
    * &::-webkit-scrollbar-thumb:hover {
        background: #323232;
    }

    h1,
    .text-xxl {
        line-height: 100%;
        font-size: var(--step-5);
    }

    h2, .text-xl {
        line-height: 100%;
        font-size: var(--step-4);
    }

    h3, .text-lg {
        font-size: var(--step-3);
        line-height: 100%;
    }

    p, span, .text-normal {
        font-size: 1rem;
        line-height: 100%;
    }

    small, .text-sm {
        font-size: var(--step--1)!important;
        line-height: 100% !important;
    }

    .text-xs {
        font-size: 0.75rem!important;
        line-height: 1rem!important;
    }

    .title {
        line-height: 100%;
        font-size: calc(var(--step-0));
    }

    .grotesk-fnt {
        font-family: SpaceGrotesk, monospace;
    }

    .text-center {
        text-align: center;
    }

    .items-center {
        align-items: center;
    }

    .justify-center {
        justify-content: center;
    }

    .justify-between {
        justify-content: space-between;
    }

    .flex-col {
        flex-direction: column !important;;
    }

    .flex-1 {
        flex: 1 1 0%;
    }

    .flex-row {
        flex-direction: row !important;
    }

    img, video {
        max-width: 100%;
        height: auto;
        vertical-align: middle;
    }

    input:not([type="image" i], [type="range" i], [type="checkbox" i], [type="radio" i]) {
        overflow-clip-margin: 0px !important;
        overflow: clip !important;
    }

    button, input, optgroup, select, textarea {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0px;
    }

    input[type="radio"] {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        width: 16px;
        height: 16px;
        border: 1px solid #3900BD;
        border-radius: 50%;
        cursor: pointer;
        position: relative;
        background-color: #F1ECFD;
        overflow: hidden;
        border-spacing: 0px;
        -webkit-border-horizontal-spacing: 0px;
        -webkit-border-vertical-spacing: 0px;
    }

    .rb-label {
        display: block;
    }

    input[type="radio"]:checked {
        border-color: #3900BD;
        border-width: 0px;;
    }

    input[type="radio"]:checked::after, {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #3900BD;
        border-radius: 50%;
    }

    button, input, optgroup, select, textarea {
        font-family: inherit;
        font-feature-settings: inherit;
        font-variation-settings: inherit;
        font-size: 100%;
        font-weight: inherit;
        line-height: inherit;
        letter-spacing: inherit;
        color: inherit;
        margin: 0;
        padding: 0;
    }

    a {
        color: var(--color-text-link);
        font-family: SpaceGrotesk, serif;
        text-decoration: none;
        cursor: pointer;
        font-weight: 500;
        letter-spacing: 0;
        font-size: var(--step--1);
    }

    a:focus:not(.focus-visible),
    *:focus {
        outline: none;
        box-shadow: none;
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .cursor-not-allowed {
        cursor: not-allowed;
    }

    .cursor-auto {
        cursor: auto;
    }

    .perfect-center {
        align-items: center;
        object-position: center;
        place-content: center;
        justify-content: center;
        margin: auto;
    }

    .avatar-base {
        width: 3rem;
        height: 3rem;
        border-radius: 50%;
        margin: auto;
    }

    .avatar-lg {
        width: 5rem;
        height: 5rem;
        border-radius: 50%;
        margin: auto;
    }

    .avatar-sm {
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        margin: auto;
    }

    .flex-between {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        justify-content: space-between;
    }

    a.focus-visible {
        outline: none;
        box-shadow: 0 0 0 3px ${getColorFromTheme("yellow100")};
    }

    .cstScroll {
        scrollbar-color: rgb(235, 235, 235) transparent;
    }

    .small-gray {
        color: var(--color-text-light);
        font-size: 14px;
        font-weight: 500;
    }

    .items-center {
        align-items: center;
    }

    .items-baseline {
        align-items: baseline;
    }

    .items-self-end {
        align-items: self-end;
    }

    .items-self-start {
        align-items: self-start;
    }

    .justify-between {
        justify-content: space-between;
    }

    .container {
        width: 100%;
    }

    ${({theme}: { theme: any }) => theme.breakpoints.up('md')} {
        .display-laptop {
            display: block;
        }

        .container {
            max-width: 768px;
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.up('lg')} {
        .container {
            max-width: 1024px;
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.up('xl')} {
        .container {
            max-width: 1366px;
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.up('xxl')} {
        .container {
            max-width: 1536px;
        }
    }

    //@media (min-width: 640px) {
    //    .container {
    //        max-width: 640px;
    //    }
    //}
    //@media (min-width: 768px) {
    //    .container {
    //        max-width: 768px;
    //    }
    //}
    //@media (min-width: 1024px) {
    //    .container {
    //        max-width: 1024px;
    //    }
    //}
    //@media (min-width: 1280px) {
    //    .container {
    //        max-width: 1280px;
    //    }
    //}
    //@media (min-width: 1536px) {
    //    .container {
    //        max-width: 1536px;
    //    }
    //}
    .shadow-sm {
        box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    }

    .transition-colors {
        transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 150ms;
    }

    .rounded-gray-card {
        user-select: none;
        background: #F9FAFB;
        border: 1px solid #D0D5DD;
        border-radius: 12px;
        padding: 15px 0px;
    }

    .rounded-gray-card.active {
        border: 1px solid color-mix(in srgb, var(--color-border) 60%, transparent);
        background: #3900BD29!important;
        color: #3900BD !important;

        span {
            color: #3900BD !important;
        }
    }

    [data-theme = "dark"] & .rounded-gray-card {
        background: var(--color-secondary-dark);
        border: 1px solid color-mix(in srgb, var(--color-border) 60%, transparent);
    }

    [data-theme = "dark"] & .rounded-gray-card.active {
        span {
            color: #ffffff !important;
        }
    }

    .shadow {
        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    }

    .shadow-md {
        box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    }

    .shadow-lg {
        box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    }

    .shadow-xl {
        box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    }

    .shadow-2xl {
        box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
    }

    .shadow-inner {
        box-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
    }

    .shadow-none {
        box-shadow: none
    }

    .float-start {
        float: inline-start
    }

    .float-end {
        float: inline-end
    }

    .float-right {
        float: right
    }

    .float-left {
        float: left
    }

    .float-none {
        float: none
    }

    .clear-start {
        clear: inline-start
    }

    .clear-end {
        clear: inline-end
    }

    .clear-left {
        clear: left
    }

    .clear-right {
        clear: right
    }

    .clear-both {
        clear: both
    }

    .clear-none {
        clear: none
    }

    .m-0 {
        margin: 0
    }

    .m-0\\.5 {
        margin: .125rem
    }

    .m-1 {
        margin: .25rem
    }

    .m-1\\.5 {
        margin: .375rem
    }

    .m-10 {
        margin: 2.5rem
    }

    .m-11 {
        margin: 2.75rem
    }

    .m-12 {
        margin: 3rem
    }

    .m-14 {
        margin: 3.5rem
    }

    .m-16 {
        margin: 4rem
    }

    .m-2 {
        margin: .5rem
    }

    .m-2\\.5 {
        margin: .625rem
    }

    .m-20 {
        margin: 5rem
    }

    .m-24 {
        margin: 6rem
    }

    .m-28 {
        margin: 7rem
    }

    .m-3 {
        margin: .75rem
    }

    .m-3\\.5 {
        margin: .875rem
    }

    .m-32 {
        margin: 8rem
    }

    .m-36 {
        margin: 9rem
    }

    .m-4 {
        margin: 1rem
    }

    .m-40 {
        margin: 10rem
    }

    .m-44 {
        margin: 11rem
    }

    .m-48 {
        margin: 12rem
    }

    .m-5 {
        margin: 1.25rem
    }

    .m-52 {
        margin: 13rem
    }

    .m-56 {
        margin: 14rem
    }

    .m-6 {
        margin: 1.5rem
    }

    .m-60 {
        margin: 15rem
    }

    .m-64 {
        margin: 16rem
    }

    .m-7 {
        margin: 1.75rem
    }

    .m-72 {
        margin: 18rem
    }

    .m-8 {
        margin: 2rem
    }

    .m-80 {
        margin: 20rem
    }

    .m-9 {
        margin: 2.25rem
    }

    .m-96 {
        margin: 24rem
    }

    .m-auto {
        margin: auto
    }

    .m-px {
        margin: 1px
    }

    .mx-0 {
        margin-left: 0;
        margin-right: 0
    }

    .mx-0\\.5 {
        margin-left: .125rem;
        margin-right: .125rem
    }

    .mx-1 {
        margin-left: .25rem;
        margin-right: .25rem
    }

    .mx-1\\.5 {
        margin-left: .375rem;
        margin-right: .375rem
    }

    .mx-10 {
        margin-left: 2.5rem;
        margin-right: 2.5rem
    }

    .mx-11 {
        margin-left: 2.75rem;
        margin-right: 2.75rem
    }

    .mx-12 {
        margin-left: 3rem;
        margin-right: 3rem
    }

    .mx-14 {
        margin-left: 3.5rem;
        margin-right: 3.5rem
    }

    .mx-16 {
        margin-left: 4rem;
        margin-right: 4rem
    }

    .mx-2 {
        margin-left: .5rem;
        margin-right: .5rem
    }

    .mx-2\\.5 {
        margin-left: .625rem;
        margin-right: .625rem
    }

    .mx-20 {
        margin-left: 5rem;
        margin-right: 5rem
    }

    .mx-24 {
        margin-left: 6rem;
        margin-right: 6rem
    }

    .mx-28 {
        margin-left: 7rem;
        margin-right: 7rem
    }

    .mx-3 {
        margin-left: .75rem;
        margin-right: .75rem
    }

    .mx-3\\.5 {
        margin-left: .875rem;
        margin-right: .875rem
    }

    .mx-32 {
        margin-left: 8rem;
        margin-right: 8rem
    }

    .mx-36 {
        margin-left: 9rem;
        margin-right: 9rem
    }

    .mx-4 {
        margin-left: 1rem;
        margin-right: 1rem
    }

    .mx-40 {
        margin-left: 10rem;
        margin-right: 10rem
    }

    .mx-44 {
        margin-left: 11rem;
        margin-right: 11rem
    }

    .mx-48 {
        margin-left: 12rem;
        margin-right: 12rem
    }

    .mx-5 {
        margin-left: 1.25rem;
        margin-right: 1.25rem
    }

    .mx-52 {
        margin-left: 13rem;
        margin-right: 13rem
    }

    .mx-56 {
        margin-left: 14rem;
        margin-right: 14rem
    }

    .mx-6 {
        margin-left: 1.5rem;
        margin-right: 1.5rem
    }

    .mx-60 {
        margin-left: 15rem;
        margin-right: 15rem
    }

    .mx-64 {
        margin-left: 16rem;
        margin-right: 16rem
    }

    .mx-7 {
        margin-left: 1.75rem;
        margin-right: 1.75rem
    }

    .mx-72 {
        margin-left: 18rem;
        margin-right: 18rem
    }

    .mx-8 {
        margin-left: 2rem;
        margin-right: 2rem
    }

    .mx-80 {
        margin-left: 20rem;
        margin-right: 20rem
    }

    .mx-9 {
        margin-left: 2.25rem;
        margin-right: 2.25rem
    }

    .mx-96 {
        margin-left: 24rem;
        margin-right: 24rem
    }

    .mx-auto {
        margin-left: auto;
        margin-right: auto
    }

    .mx-px {
        margin-left: 1px;
        margin-right: 1px
    }

    .my-0 {
        margin-top: 0;
        margin-bottom: 0
    }

    .my-0\\.5 {
        margin-top: .125rem;
        margin-bottom: .125rem
    }

    .my-1 {
        margin-top: .25rem;
        margin-bottom: .25rem
    }

    .my-1\\.5 {
        margin-top: .375rem;
        margin-bottom: .375rem
    }

    .my-10 {
        margin-top: 2.5rem;
        margin-bottom: 2.5rem
    }

    .my-11 {
        margin-top: 2.75rem;
        margin-bottom: 2.75rem
    }

    .my-12 {
        margin-top: 3rem;
        margin-bottom: 3rem
    }

    .my-14 {
        margin-top: 3.5rem;
        margin-bottom: 3.5rem
    }

    .my-16 {
        margin-top: 4rem;
        margin-bottom: 4rem
    }

    .my-2 {
        margin-top: .5rem;
        margin-bottom: .5rem
    }

    .my-2\\.5 {
        margin-top: .625rem;
        margin-bottom: .625rem
    }

    .my-20 {
        margin-top: 5rem;
        margin-bottom: 5rem
    }

    .my-24 {
        margin-top: 6rem;
        margin-bottom: 6rem
    }

    .my-28 {
        margin-top: 7rem;
        margin-bottom: 7rem
    }

    .my-3 {
        margin-top: .75rem;
        margin-bottom: .75rem
    }

    .my-3\\.5 {
        margin-top: .875rem;
        margin-bottom: .875rem
    }

    .my-32 {
        margin-top: 8rem;
        margin-bottom: 8rem
    }

    .my-36 {
        margin-top: 9rem;
        margin-bottom: 9rem
    }

    .my-4 {
        margin-top: 1rem;
        margin-bottom: 1rem
    }

    .my-40 {
        margin-top: 10rem;
        margin-bottom: 10rem
    }

    .my-44 {
        margin-top: 11rem;
        margin-bottom: 11rem
    }

    .my-48 {
        margin-top: 12rem;
        margin-bottom: 12rem
    }

    .my-5 {
        margin-top: 1.25rem;
        margin-bottom: 1.25rem
    }

    .my-52 {
        margin-top: 13rem;
        margin-bottom: 13rem
    }

    .my-56 {
        margin-top: 14rem;
        margin-bottom: 14rem
    }

    .my-6 {
        margin-top: 1.5rem;
        margin-bottom: 1.5rem
    }

    .my-60 {
        margin-top: 15rem;
        margin-bottom: 15rem
    }

    .my-64 {
        margin-top: 16rem;
        margin-bottom: 16rem
    }

    .my-7 {
        margin-top: 1.75rem;
        margin-bottom: 1.75rem
    }

    .my-72 {
        margin-top: 18rem;
        margin-bottom: 18rem
    }

    .my-8 {
        margin-top: 2rem;
        margin-bottom: 2rem
    }

    .my-80 {
        margin-top: 20rem;
        margin-bottom: 20rem
    }

    .my-9 {
        margin-top: 2.25rem;
        margin-bottom: 2.25rem
    }

    .my-96 {
        margin-top: 24rem;
        margin-bottom: 24rem
    }

    .my-auto {
        margin-top: auto;
        margin-bottom: auto
    }

    .my-px {
        margin-top: 1px;
        margin-bottom: 1px
    }

    .mb-0 {
        margin-bottom: 0
    }

    .mb-0\\.5 {
        margin-bottom: .125rem
    }

    .mb-1 {
        margin-bottom: .25rem
    }

    .mb-1\\.5 {
        margin-bottom: .375rem
    }

    .mb-10 {
        margin-bottom: 2.5rem
    }

    .mb-11 {
        margin-bottom: 2.75rem
    }

    .mb-12 {
        margin-bottom: 3rem
    }

    .mb-14 {
        margin-bottom: 3.5rem
    }

    .mb-16 {
        margin-bottom: 4rem
    }

    .mb-2 {
        margin-bottom: .5rem
    }

    .mb-2\\.5 {
        margin-bottom: .625rem
    }

    .mb-20 {
        margin-bottom: 5rem
    }

    .mb-24 {
        margin-bottom: 6rem
    }

    .mb-28 {
        margin-bottom: 7rem
    }

    .mb-3 {
        margin-bottom: .75rem
    }

    .mb-3\\.5 {
        margin-bottom: .875rem
    }

    .mb-32 {
        margin-bottom: 8rem
    }

    .mb-36 {
        margin-bottom: 9rem
    }

    .mb-4 {
        margin-bottom: 1rem
    }

    .mb-40 {
        margin-bottom: 10rem
    }

    .mb-44 {
        margin-bottom: 11rem
    }

    .mb-48 {
        margin-bottom: 12rem
    }

    .mb-5 {
        margin-bottom: 1.25rem
    }

    .mb-52 {
        margin-bottom: 13rem
    }

    .mb-56 {
        margin-bottom: 14rem
    }

    .mb-6 {
        margin-bottom: 1.5rem
    }

    .mb-60 {
        margin-bottom: 15rem
    }

    .mb-64 {
        margin-bottom: 16rem
    }

    .mb-7 {
        margin-bottom: 1.75rem
    }

    .mb-72 {
        margin-bottom: 18rem
    }

    .mb-8 {
        margin-bottom: 2rem
    }

    .mb-80 {
        margin-bottom: 20rem
    }

    .mb-9 {
        margin-bottom: 2.25rem
    }

    .mb-96 {
        margin-bottom: 24rem
    }

    .mb-auto {
        margin-bottom: auto
    }

    .mb-px {
        margin-bottom: 1px
    }

    .me-0 {
        margin-inline-end: 0
    }

    .me-0\\.5 {
        margin-inline-end: .125rem
    }

    .me-1 {
        margin-inline-end: .25rem
    }

    .me-1\\.5 {
        margin-inline-end: .375rem
    }

    .me-10 {
        margin-inline-end: 2.5rem
    }

    .me-11 {
        margin-inline-end: 2.75rem
    }

    .me-12 {
        margin-inline-end: 3rem
    }

    .me-14 {
        margin-inline-end: 3.5rem
    }

    .me-16 {
        margin-inline-end: 4rem
    }

    .me-2 {
        margin-inline-end: .5rem
    }

    .me-2\\.5 {
        margin-inline-end: .625rem
    }

    .me-20 {
        margin-inline-end: 5rem
    }

    .me-24 {
        margin-inline-end: 6rem
    }

    .me-28 {
        margin-inline-end: 7rem
    }

    .me-3 {
        margin-inline-end: .75rem
    }

    .me-3\\.5 {
        margin-inline-end: .875rem
    }

    .me-32 {
        margin-inline-end: 8rem
    }

    .me-36 {
        margin-inline-end: 9rem
    }

    .me-4 {
        margin-inline-end: 1rem
    }

    .me-40 {
        margin-inline-end: 10rem
    }

    .me-44 {
        margin-inline-end: 11rem
    }

    .me-48 {
        margin-inline-end: 12rem
    }

    .me-5 {
        margin-inline-end: 1.25rem
    }

    .me-52 {
        margin-inline-end: 13rem
    }

    .me-56 {
        margin-inline-end: 14rem
    }

    .me-6 {
        margin-inline-end: 1.5rem
    }

    .me-60 {
        margin-inline-end: 15rem
    }

    .me-64 {
        margin-inline-end: 16rem
    }

    .me-7 {
        margin-inline-end: 1.75rem
    }

    .me-72 {
        margin-inline-end: 18rem
    }

    .me-8 {
        margin-inline-end: 2rem
    }

    .me-80 {
        margin-inline-end: 20rem
    }

    .me-9 {
        margin-inline-end: 2.25rem
    }

    .me-96 {
        margin-inline-end: 24rem
    }

    .me-auto {
        margin-inline-end: auto
    }

    .me-px {
        margin-inline-end: 1px
    }

    .ml-0 {
        margin-left: 0
    }

    .ml-0\\.5 {
        margin-left: .125rem
    }

    .ml-1 {
        margin-left: .25rem
    }

    .ml-1\\.5 {
        margin-left: .375rem
    }

    .ml-10 {
        margin-left: 2.5rem
    }

    .ml-11 {
        margin-left: 2.75rem
    }

    .ml-12 {
        margin-left: 3rem
    }

    .ml-14 {
        margin-left: 3.5rem
    }

    .ml-16 {
        margin-left: 4rem
    }

    .ml-2 {
        margin-left: .5rem
    }

    .ml-2\\.5 {
        margin-left: .625rem
    }

    .ml-20 {
        margin-left: 5rem
    }

    .ml-24 {
        margin-left: 6rem
    }

    .ml-28 {
        margin-left: 7rem
    }

    .ml-3 {
        margin-left: .75rem
    }

    .ml-3\\.5 {
        margin-left: .875rem
    }

    .ml-32 {
        margin-left: 8rem
    }

    .ml-36 {
        margin-left: 9rem
    }

    .ml-4 {
        margin-left: 1rem
    }

    .ml-40 {
        margin-left: 10rem
    }

    .ml-44 {
        margin-left: 11rem
    }

    .ml-48 {
        margin-left: 12rem
    }

    .ml-5 {
        margin-left: 1.25rem
    }

    .ml-52 {
        margin-left: 13rem
    }

    .ml-56 {
        margin-left: 14rem
    }

    .ml-6 {
        margin-left: 1.5rem
    }

    .ml-60 {
        margin-left: 15rem
    }

    .ml-64 {
        margin-left: 16rem
    }

    .ml-7 {
        margin-left: 1.75rem
    }

    .ml-72 {
        margin-left: 18rem
    }

    .ml-8 {
        margin-left: 2rem
    }

    .ml-80 {
        margin-left: 20rem
    }

    .ml-9 {
        margin-left: 2.25rem
    }

    .ml-96 {
        margin-left: 24rem
    }

    .ml-auto {
        margin-left: auto
    }

    .ml-px {
        margin-left: 1px
    }

    .mr-0 {
        margin-right: 0
    }

    .mr-0\\.5 {
        margin-right: .125rem
    }

    .mr-1 {
        margin-right: .25rem
    }

    .mr-1\\.5 {
        margin-right: .375rem
    }

    .mr-10 {
        margin-right: 2.5rem
    }

    .mr-11 {
        margin-right: 2.75rem
    }

    .mr-12 {
        margin-right: 3rem
    }

    .mr-14 {
        margin-right: 3.5rem
    }

    .mr-16 {
        margin-right: 4rem
    }

    .mr-2 {
        margin-right: .5rem
    }

    .mr-2\\.5 {
        margin-right: .625rem
    }

    .mr-20 {
        margin-right: 5rem
    }

    .mr-24 {
        margin-right: 6rem
    }

    .mr-28 {
        margin-right: 7rem
    }

    .mr-3 {
        margin-right: .75rem
    }

    .mr-3\\.5 {
        margin-right: .875rem
    }

    .mr-32 {
        margin-right: 8rem
    }

    .mr-36 {
        margin-right: 9rem
    }

    .mr-4 {
        margin-right: 1rem
    }

    .mr-40 {
        margin-right: 10rem
    }

    .mr-44 {
        margin-right: 11rem
    }

    .mr-48 {
        margin-right: 12rem
    }

    .mr-5 {
        margin-right: 1.25rem
    }

    .mr-52 {
        margin-right: 13rem
    }

    .mr-56 {
        margin-right: 14rem
    }

    .mr-6 {
        margin-right: 1.5rem
    }

    .mr-60 {
        margin-right: 15rem
    }

    .mr-64 {
        margin-right: 16rem
    }

    .mr-7 {
        margin-right: 1.75rem
    }

    .mr-72 {
        margin-right: 18rem
    }

    .mr-8 {
        margin-right: 2rem
    }

    .mr-80 {
        margin-right: 20rem
    }

    .mr-9 {
        margin-right: 2.25rem
    }

    .mr-96 {
        margin-right: 24rem
    }

    .mr-auto {
        margin-right: auto
    }

    .mr-px {
        margin-right: 1px
    }

    .ms-0 {
        margin-inline-start: 0
    }

    .ms-0\\.5 {
        margin-inline-start: .125rem
    }

    .ms-1 {
        margin-inline-start: .25rem
    }

    .ms-1\\.5 {
        margin-inline-start: .375rem
    }

    .ms-10 {
        margin-inline-start: 2.5rem
    }

    .ms-11 {
        margin-inline-start: 2.75rem
    }

    .ms-12 {
        margin-inline-start: 3rem
    }

    .ms-14 {
        margin-inline-start: 3.5rem
    }

    .ms-16 {
        margin-inline-start: 4rem
    }

    .ms-2 {
        margin-inline-start: .5rem
    }

    .ms-2\\.5 {
        margin-inline-start: .625rem
    }

    .ms-20 {
        margin-inline-start: 5rem
    }

    .ms-24 {
        margin-inline-start: 6rem
    }

    .ms-28 {
        margin-inline-start: 7rem
    }

    .ms-3 {
        margin-inline-start: .75rem
    }

    .ms-3\\.5 {
        margin-inline-start: .875rem
    }

    .ms-32 {
        margin-inline-start: 8rem
    }

    .ms-36 {
        margin-inline-start: 9rem
    }

    .ms-4 {
        margin-inline-start: 1rem
    }

    .ms-40 {
        margin-inline-start: 10rem
    }

    .ms-44 {
        margin-inline-start: 11rem
    }

    .ms-48 {
        margin-inline-start: 12rem
    }

    .ms-5 {
        margin-inline-start: 1.25rem
    }

    .ms-52 {
        margin-inline-start: 13rem
    }

    .ms-56 {
        margin-inline-start: 14rem
    }

    .ms-6 {
        margin-inline-start: 1.5rem
    }

    .ms-60 {
        margin-inline-start: 15rem
    }

    .ms-64 {
        margin-inline-start: 16rem
    }

    .ms-7 {
        margin-inline-start: 1.75rem
    }

    .ms-72 {
        margin-inline-start: 18rem
    }

    .ms-8 {
        margin-inline-start: 2rem
    }

    .ms-80 {
        margin-inline-start: 20rem
    }

    .ms-9 {
        margin-inline-start: 2.25rem
    }

    .ms-96 {
        margin-inline-start: 24rem
    }

    .ms-auto {
        margin-inline-start: auto
    }

    .ms-px {
        margin-inline-start: 1px
    }

    .mt-0 {
        margin-top: 0
    }

    .mt-0\\.5 {
        margin-top: .125rem
    }

    .mt-1 {
        margin-top: .25rem
    }

    .mt-1\\.5 {
        margin-top: .375rem
    }

    .mt-10 {
        margin-top: 2.5rem
    }

    .mt-11 {
        margin-top: 2.75rem
    }

    .mt-12 {
        margin-top: 3rem
    }

    .mt-14 {
        margin-top: 3.5rem
    }

    .mt-16 {
        margin-top: 4rem
    }

    .mt-2 {
        margin-top: .5rem
    }

    .mt-2\\.5 {
        margin-top: .625rem
    }

    .mt-20 {
        margin-top: 5rem
    }

    .mt-24 {
        margin-top: 6rem
    }

    .mt-28 {
        margin-top: 7rem
    }

    .mt-3 {
        margin-top: .75rem
    }

    .mt-3\\.5 {
        margin-top: .875rem
    }

    .mt-32 {
        margin-top: 8rem
    }

    .mt-36 {
        margin-top: 9rem
    }

    .mt-4 {
        margin-top: 1rem
    }

    .mt-40 {
        margin-top: 10rem
    }

    .mt-44 {
        margin-top: 11rem
    }

    .mt-48 {
        margin-top: 12rem
    }

    .mt-5 {
        margin-top: 1.25rem
    }

    .mt-52 {
        margin-top: 13rem
    }

    .mt-56 {
        margin-top: 14rem
    }

    .mt-6 {
        margin-top: 1.5rem
    }

    .mt-60 {
        margin-top: 15rem
    }

    .mt-64 {
        margin-top: 16rem
    }

    .mt-7 {
        margin-top: 1.75rem
    }

    .mt-72 {
        margin-top: 18rem
    }

    .mt-8 {
        margin-top: 2rem
    }

    .mt-80 {
        margin-top: 20rem
    }

    .mt-9 {
        margin-top: 2.25rem
    }

    .mt-96 {
        margin-top: 24rem
    }

    .mt-auto {
        margin-top: auto
    }

    .mt-px {
        margin-top: 1px
    }

    .box-border {
        box-sizing: border-box
    }

    .box-content {
        box-sizing: initial
    }

    .line-clamp-1 {
        -webkit-line-clamp: 1
    }

    .line-clamp-1, .line-clamp-2 {
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical
    }

    .line-clamp-2 {
        -webkit-line-clamp: 2
    }

    .line-clamp-3 {
        -webkit-line-clamp: 3
    }

    .line-clamp-3, .line-clamp-4 {
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical
    }

    .line-clamp-4 {
        -webkit-line-clamp: 4
    }

    .line-clamp-5 {
        -webkit-line-clamp: 5
    }

    .line-clamp-5, .line-clamp-6 {
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical
    }

    .line-clamp-6 {
        -webkit-line-clamp: 6
    }

    .line-clamp-none {
        overflow: visible;
        display: block;
        -webkit-box-orient: horizontal;
        -webkit-line-clamp: none
    }

    .block {
        display: block
    }

    .inline-block {
        display: inline-block
    }

    .inline {
        display: inline
    }

    .flex {
        display: flex
    }

    .inline-flex {
        display: inline-flex
    }

    .table {
        display: table
    }

    .inline-table {
        display: inline-table
    }

    .table-caption {
        display: table-caption
    }

    .table-cell {
        display: table-cell
    }

    .table-column {
        display: table-column
    }

    .table-column-group {
        display: table-column-group
    }

    .table-footer-group {
        display: table-footer-group
    }

    .table-header-group {
        display: table-header-group
    }

    .table-row-group {
        display: table-row-group
    }

    .table-row {
        display: table-row
    }

    .flow-root {
        display: flow-root
    }

    .grid {
        display: grid
    }

    .inline-grid {
        display: inline-grid
    }

    .contents {
        display: contents
    }

    .list-item {
        display: list-item
    }

    .hidden {
        display: none
    }

    .aspect-auto {
        aspect-ratio: auto
    }

    .aspect-square {
        aspect-ratio: 1/1
    }

    .aspect-video {
        aspect-ratio: 16/9
    }
`;
